<style lang="scss">
  .truncate-title {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    overflow: hidden;
  }
</style>

<script>
  let { title = "" } = $props();
</script>

<span class="truncate-title">{title}</span>
